import React from 'react';
import PropTypes from 'prop-types';
import { IconContainer } from './style';

var Icon = function Icon(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '24px' : _ref$size,
      title = _ref.title,
      children = _ref.children,
      height = _ref.height,
      width = _ref.width;
  return React.createElement("svg", {
    width: width,
    height: height,
    viewBox: "0 0 24 24"
  }, React.createElement("title", null, title), children);
};

var IconCart = function IconCart(_ref2) {
  var _ref2$size = _ref2.size,
      size = _ref2$size === void 0 ? '24px' : _ref2$size,
      title = _ref2.title,
      children = _ref2.children,
      height = _ref2.height,
      width = _ref2.width;
  return React.createElement("svg", {
    width: width,
    height: height,
    viewBox: "0 0 28 26"
  }, React.createElement("title", null, title), children);
};

export var DownloadIcon = function DownloadIcon(props) {
  return React.createElement(IconContainer, {
    width: props.size,
    height: props.size
  }, React.createElement(Icon, {
    size: props.size
  }, React.createElement("path", {
    className: "path",
    fill: props.color,
    d: "M11.25 15.85l-4.38-4.38a.75.75 0 0 0-1.06 1.06l4.95 4.95c.69.68 1.8.68 2.48 0l4.95-4.95a.75.75 0 1 0-1.06-1.06l-4.38 4.38V4.25a.75.75 0 1 0-1.5 0v11.6zm-7.5 3.4h16.5a.75.75 0 1 1 0 1.5H3.75a.75.75 0 1 1 0-1.5z"
  })));
};
export var ShoppingCartIcon = function ShoppingCartIcon(props) {
  return React.createElement(IconContainer, {
    width: props.width,
    height: props.height
  }, React.createElement(IconCart, {
    size: props.size
  }, React.createElement("path", {
    d: "M19.00599976158142,5.021281929016113 c-0.19100000000000023,-0.21900000000000017 -0.466,-0.3450000000000005 -0.7560000000000007,-0.3450000000000005 H4.430999761581422 L4.2359997615814216,3.5122819290161136 C4.15599976158142,3.0302819290161134 3.7389997615814217,2.6762819290161133 3.249999761581421,2.6762819290161133 H0.999999761581421 c-0.553,0 -1,0.4470000000000004 -1,1 s0.4470000000000004,1 1,1 h1.403 l1.86,11.164 c0.00800000000000001,0.04500000000000007 0.03100000000000004,0.0820000000000001 0.04500000000000007,0.12400000000000008 c0.01600000000000002,0.05300000000000007 0.029000000000000033,0.10300000000000002 0.054000000000000076,0.15100000000000016 c0.03200000000000004,0.06600000000000009 0.07500000000000002,0.12200000000000008 0.12000000000000002,0.17900000000000016 c0.03100000000000004,0.03900000000000004 0.05900000000000006,0.07800000000000008 0.09500000000000017,0.11200000000000009 c0.05800000000000006,0.054000000000000076 0.125,0.09200000000000016 0.19300000000000023,0.13 c0.03800000000000001,0.021000000000000026 0.07100000000000002,0.04900000000000005 0.11200000000000009,0.06500000000000009 c0.11600000000000012,0.04700000000000004 0.23800000000000004,0.07500000000000002 0.3670000000000003,0.07500000000000002 c0.0010000000000000013,0 11.001,0 11.001,0 c0.553,0 1,-0.4470000000000004 1,-1 s-0.4470000000000004,-1 -1,-1 H6.096999761581422 l-0.16600000000000023,-1 H17.249999761581424 c0.49800000000000033,0 0.92,-0.3660000000000003 0.99,-0.8580000000000007 l1,-7 C19.28099976158142,5.530281929016113 19.19499976158142,5.239281929016114 19.00599976158142,5.021281929016113 zM17.096999761581422,6.676281929016114 l-0.2850000000000003,2 H13.249999761581421 v-2 H17.096999761581422 zM12.249999761581421,6.676281929016114 v2 h-3 v-2 H12.249999761581421 zM12.249999761581421,9.676281929016113 v2 h-3 v-2 H12.249999761581421 zM8.249999761581421,6.676281929016114 v2 h-3 c-0.05300000000000007,0 -0.101,0.015000000000000019 -0.14800000000000016,0.03000000000000004 l-0.33800000000000047,-2.03 H8.249999761581421 zM5.26399976158142,9.676281929016113 H8.249999761581421 v2 H5.596999761581422 L5.26399976158142,9.676281929016113 zM13.249999761581421,11.676281929016113 v-2 h3.418 l-0.2850000000000003,2 H13.249999761581421 z",
    fill: props.color,
    id: "svg_3"
  }), React.createElement("circle", {
    cx: "6.749999523162842",
    cy: "19.176281452178955",
    r: "1.5",
    fill: "#6bcde7",
    id: "svg_4"
  }), React.createElement("circle", {
    cx: "15.75",
    cy: "19.176281452178955",
    r: "1.5",
    fill: "#6bcde7",
    id: "svg_5"
  }), React.createElement("path", {
    fill: "#9de042",
    fillOpacity: "1",
    stroke: "#9de042",
    strokeWidth: "1",
    strokeDasharray: "none",
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeDashoffset: "",
    fillRule: "nonzero",
    opacity: "1",
    markerStart: "",
    markerMid: "",
    markerEnd: "",
    d: "M15.435897588729858,5.346153663958092 C15.435897588729858,2.831633320472876 17.472659066952886,0.7948718422498482 19.987179410438102,0.7948718422498482 C22.50169975392332,0.7948718422498482 24.538461232146346,2.831633320472876 24.538461232146346,5.346153663958092 C24.538461232146346,7.860674007443311 22.50169975392332,9.897435485666337 19.987179410438102,9.897435485666337 C17.472659066952886,9.897435485666337 15.435897588729858,7.860674007443311 15.435897588729858,5.346153663958092 z",
    id: "svg_21",
    className: "",
    strokeOpacity: "1"
  }), React.createElement("text", {
    fontSize: "8px",
    x: "17.5",
    y: "8",
    fill: "black"
  }, props.counter)));
};
DownloadIcon.propTypes = {
  active: PropTypes.bool,
  size: PropTypes.string,
  color: PropTypes.string
};
ShoppingCartIcon.propTypes = {
  active: PropTypes.bool,
  height: PropTypes.string,
  width: PropTypes.string,
  size: PropTypes.string,
  counter: PropTypes.number,
  color: PropTypes.string
};
Icon.propTypes = {
  size: PropTypes.string,
  height: PropTypes.string,
  width: PropTypes.string,
  color: PropTypes.string,
  title: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array])
};
IconCart.propTypes = {
  size: PropTypes.string,
  height: PropTypes.string,
  width: PropTypes.string,
  color: PropTypes.string,
  title: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array])
};